import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import {
  FileUploadV2Module,
  IconV2Module,
  ModalModule,
  PagesModule,
  RadioV2Module,
  TextInputModule,
  ButtonV2Module,
  AccordionV2Module,
  TabModule,
  ChipV2Module,
  SelectV2Module,
  InputV2Module,
  ToggleV2Module,
} from '@schenck/rotec-components';
import { PipesModule } from 'src/pipes/pipes.module';
import { CancelEditModalComponent } from './modal/cancel-edit-modal.component';
import { TemplateCanvasItemComponent } from './template-canvas/template-canvas-item/template-canvas-item.component';
import { TemplateCanvasRegionComponent } from './template-canvas/template-canvas-region/template-canvas-region.component';
import { TemplateCanvasComponent } from './template-canvas/template-canvas.component';
import { TemplateEditorComponent } from './template-editor.component';
import { TemplateToolboxCategoryFreetextComponent } from './template-toolbox/template-toolbox-category-freetext/template-toolbox-category-freetext.component';
import { TemplateToolboxCategoryHeaderComponent } from './template-toolbox/template-toolbox-category-header/template-toolbox-category-header.component';
import { TemplateToolboxCategorySettingsComponent } from './template-toolbox/template-toolbox-category-settings/template-toolbox-category-settings.component';
import { TemplateToolboxCategoryComponent } from './template-toolbox/template-toolbox-category/template-toolbox-category.component';
import { TemplateToolboxItemFilterPipe } from './template-toolbox/template-toolbox-item-filter.pipe';
import { TemplateToolboxItemFreetextComponent } from './template-toolbox/template-toolbox-item-freetext/template-toolbox-item-freetext.component';
import { TemplateToolboxItemComponent } from './template-toolbox/template-toolbox-item/template-toolbox-item.component';
import { TemplateToolboxComponent } from './template-toolbox/template-toolbox.component';

@NgModule({
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    // Angular Material
    DragDropModule,
    MatExpansionModule,
    MatCardModule,
    MatListModule,
    MatTabsModule,
    MatButtonToggleModule,
    //RoTec Components
    FileUploadV2Module,
    TextInputModule,
    PagesModule,
    ModalModule,
    IconV2Module,
    PipesModule,
    RadioV2Module,
    ButtonV2Module,
    AccordionV2Module,
    TabModule,
    ChipV2Module,
    SelectV2Module,
    InputV2Module,
    ToggleV2Module,
    TemplateEditorComponent,
    TemplateCanvasComponent,
    TemplateToolboxComponent,
    TemplateCanvasRegionComponent,
    TemplateCanvasItemComponent,
    TemplateToolboxItemComponent,
    TemplateToolboxCategoryComponent,
    TemplateToolboxItemFilterPipe,
    CancelEditModalComponent,
    TemplateToolboxCategorySettingsComponent,
    TemplateToolboxCategoryFreetextComponent,
    TemplateToolboxItemFreetextComponent,
    TemplateToolboxCategoryHeaderComponent,
  ],
  exports: [TemplateEditorComponent],
})
export class TemplateEditorModule {}
